import React, { useState } from "react";
import AuthConsumer from "../../utils/auth";

import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { links } from "../../data/nav";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/slices/NavigationSlice";

import "./header.css";
import { message } from "antd";

/* nav icons keyed by link.key */
const icons = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  customer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    </svg>
  ),
  worker: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 7h-9M14 17H5M17 3l3 4-3 4M7 21l-3-4 3-4" />
    </svg>
  ),
  expense: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
};

export const Header = () => {
  const redux = useDispatch();
  const { t, i18n } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");

  const [, dispatch] = AuthConsumer();
  const [current, setCurrent] = useState(lang || "gu");

  const languages = [
    { code: "gu", label: "ગુ", name: "ગુજરાતી" },
    { code: "hi", label: "हि", name: "हिन्दी" },
    { code: "en", label: "EN", name: "English" },
  ];

  const activeIndex = Math.max(
    0,
    languages.findIndex((l) => l.code === current),
  );

  const handleLanguageChange = (code) => {
    setCurrent(code);
    redux(setLanguage({ toggle: code }));
    i18n.changeLanguage(code);
  };

  return (
    <nav className="dp-rail" aria-label="Primary">
      {/* brand mark */}
      <Link to="/" replace="true" className="dp-rail-mark" title="Darji Point">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="6" cy="6" r="3" />
          <circle cx="6" cy="18" r="3" />
          <path d="M20 4 8.12 15.88M14.47 14.48 20 20M8.12 8.12 12 12" />
        </svg>
      </Link>

      {/* primary nav */}
      <div className="dp-rail-nav">
        {links.map((link) => (
          <NavLink
            key={link.key}
            to={link.path}
            end={link.path === "/"}
            className={({ isActive }) =>
              isActive ? "dp-rail-item active" : "dp-rail-item"
            }
          >
            {icons[link.key]}
            <span>{t(link.name)}</span>
          </NavLink>
        ))}
      </div>

      <div className="dp-rail-spacer" />

      {/* language toggle */}
      <div
        className="dp-lang"
        role="radiogroup"
        aria-label={t("common.language")}
      >
        <span
          className="dp-lang-thumb"
          aria-hidden="true"
          style={{ transform: `translateY(${activeIndex * 100}%)` }}
        />
        {languages.map((l) => (
          <button
            key={l.code}
            type="button"
            role="radio"
            aria-checked={current === l.code}
            title={l.name}
            className={current === l.code ? "dp-lang-opt on" : "dp-lang-opt"}
            onClick={() => handleLanguageChange(l.code)}
          >
            {l.label}
          </button>
        ))}
      </div>

      {/* logout */}
      <button
        type="button"
        className="dp-rail-item dp-logout"
        title={t("nav.logout")}
        onClick={() => {
          message.info(t("common.exit"));
          dispatch({ type: "logout" });
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
        <span>{t("nav.logout")}</span>
      </button>
    </nav>
  );
};

export default Header;
